const images = [
  {
    src: "https://readdy.ai/api/search-image?query=sleek%20modern%20Silicon%20Valley%20tech%20office%20interior%20with%20open%20plan%20workspace%2C%20floor-to-ceiling%20glass%20walls%20overlooking%20a%20sunny%20California%20landscape%2C%20pristine%20white%20walls%2C%20polished%20concrete%20floors%2C%20lush%20greenery%20and%20potted%20plants%2C%20warm%20California%20sunlight%20streaming%20in%2C%20minimalist%20contemporary%20furniture%20in%20warm%20white%20and%20natural%20wood%20tones%2C%20airy%20and%20inspiring%20atmosphere%2C%20no%20people%2C%20ultra%20high%20quality%20professional%20architectural%20interior%20photography&width=600&height=500&seq=sv-origin-01&orientation=squarish",
    alt: "Airdog founded in Silicon Valley — modern tech office interior",
  },
  {
    src: "https://readdy.ai/api/search-image?query=sleek%20contemporary%20open-concept%20premium%20retail%20showroom%20interior%20with%20pristine%20white%20walls%2C%20polished%20light%20wood%20floors%2C%20large%20floor-to-ceiling%20windows%20flooding%20the%20space%20with%20soft%20natural%20daylight%2C%20minimalist%20product%20display%20shelves%20with%20clean%20airy%20spacing%2C%20lush%20indoor%20potted%20plants%2C%20warm%20neutral%20tones%20of%20white%20cream%20and%20natural%20wood%2C%20calm%20sophisticated%20commercial%20atmosphere%2C%20no%20people%2C%20ultra%20high%20quality%20professional%20architectural%20interior%20photography&width=600&height=500&seq=retail-clean-match-07&orientation=squarish",
    alt: "Airdog trusted by global premium retailers and luxury department stores",
  },
  {
    src: "https://readdy.ai/api/search-image?query=elegant%20modern%20German%20school%20classroom%20or%20medical%20facility%20interior%20with%20pristine%20white%20walls%2C%20large%20floor-to-ceiling%20windows%20flooding%20the%20room%20with%20bright%20natural%20daylight%2C%20minimalist%20Bauhaus-inspired%20furniture%2C%20clean%20geometric%20lines%2C%20lush%20indoor%20plants%2C%20warm%20neutral%20tones%20of%20white%20grey%20and%20light%20oak%20wood%2C%20highly%20polished%20floors%2C%20sophisticated%20and%20calm%20atmosphere%2C%20no%20people%2C%20ultra%20high%20quality%20professional%20architectural%20interior%20photography&width=600&height=500&seq=de-precision-01&orientation=squarish",
    alt: "Airdog deployed across German schools and medical facilities",
  },
  {
    src: "https://storage.readdy-site.link/project_files/0ab4d894-9a87-4492-8cdb-8328f902642e/8eec4669-7b01-4c83-97dc-f4120f17d6b2_japan-airport-clip.jpg?v=bdc034cc3e0e60aae35c6d3db86d2f3e",
    alt: "Airdog protects air quality at major Japan airports",
  },
];

const cardData = [
  {
    label: "Founded 2007 — Silicon Valley",
    labelColor: "text-red-600",
    bgColor: "bg-red-50",
    borderColor: "border-red-100",
    text: "Founded in Silicon Valley in 2007, Airdog was born to disrupt the status quo. We pioneered Airdog TPA® technology to eliminate the waste and limitations of traditional HEPA filters. By replacing costly, landfill-bound disposables with a washable, reusable system that never loses efficiency, we deliver pure, sanitized air without compromise.",
  },
  {
    label: "Trusted by Global Brands & Premium Retailers",
    labelColor: "text-amber-600",
    bgColor: "bg-amber-50",
    borderColor: "border-amber-100",
    text: "From medical facilities and schools to Japan's elite department stores like Takashimaya and Daimaru, the world's top venues choose Airdog. Engineered for high-traffic environments, we deliver continuous, active air sanitation—keeping luxury spaces and essential institutions safe, fresh, and welcoming for thousands daily.",
  },
  {
    label: "German Precision: The Gold Standard",
    labelColor: "text-emerald-600",
    bgColor: "bg-emerald-50",
    borderColor: "border-emerald-100",
    text: "Chosen by German medical and educational experts, Airdog protects high-traffic environments across more than 6,000 schools and medical facilities. Adhering to the world's most rigorous industrial benchmarks, our technology is validated by international safety bodies, certified ozone-safe, and proven to maintain 99.9% bio-aerosol destruction under continuous operation.",
  },
  {
    label: "Trusted at Major Japan Airports",
    labelColor: "text-slate-600",
    bgColor: "bg-slate-50",
    borderColor: "border-slate-100",
    text: "Airdog protects air quality at Haneda, Narita, Kansai, and Itami airports, ensuring clean, safe breathing for millions of travelers. Our medical-grade TPA technology operates continuously in the world's busiest terminals, providing active air sanitation without the burden of disposable filter replacements.",
  },
];

export default function ImageGallerySection() {
  return (
    <section id="story" className="relative py-10 md:py-14 scroll-mt-20 bg-white">
      {/* Visual separator */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-red-500/20 to-transparent" />

      <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl w-full">

        {/* Section Header */}
        <div className="text-center mb-6 md:mb-8">
          <span className="inline-block text-xs font-bold tracking-[0.2em] uppercase text-red-600 mb-2">
            Our Story
          </span>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-extrabold text-gray-900 leading-tight mb-2">
            Born in Silicon Valley. Trusted Worldwide.
          </h2>
          <p className="text-sm text-gray-600 font-bold max-w-xl mx-auto">
            From California startups to German medical facilities, Tokyo luxury retailers, and Japan's busiest airports.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {images.map((img, i) => (
            <div key={i} className="flex flex-col gap-2 h-full">
              <div className="overflow-hidden rounded-lg shrink-0 bg-gray-50 h-28 sm:h-32 lg:h-36">
                <img
                  src={img.src}
                  alt={img.alt}
                  title={img.alt}
                  className="w-full h-full object-contain object-center"
                />
              </div>
              <div className={`flex-1 rounded-lg p-3 md:p-4 ${cardData[i].bgColor} border ${cardData[i].borderColor}`}>
                <p className={`text-[10px] font-bold tracking-widest uppercase mb-1.5 ${cardData[i].labelColor}`}>
                  {cardData[i].label}
                </p>
                <p className="text-[11px] md:text-xs leading-relaxed text-gray-800">
                  {cardData[i].text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Bottom separator */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-red-500/20 to-transparent" />
    </section>
  );
}